import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from 'src/api/instance';

export interface AdvTranslation {
  lang: string;
  homeTitle?: string;
  modalTitle?: string;
  modalDescription?: string;
}

export interface AdvData {
  home_preview_url: string;
  modal_preview_url?: string | null;
  show_at_session_start: boolean;
  translations: {
    [lang: string]: Omit<AdvTranslation, 'lang'>;
  };
}

export interface AdvTypes {
  id: string;
  companyId: string;
  homePreviewUrl: string;
  modalPreviewUrl: string | null;
  showAtSessionStart: boolean;
  translations: AdvTranslation[];
}

const companyAdvHomePath = (companyId: string) => `/companies/${companyId}/advertisements/home`;

export const getAdv = async ({ companyId }: { companyId: string }): Promise<AxiosResponse<AdvTypes>> => {
  return instance.get(companyAdvHomePath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const createAdv = async ({ companyId, data }: { companyId: string; data: AdvData }) => {
  return instance
    .post<AdvTypes>(companyAdvHomePath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateAdv = async ({ companyId, data }: { companyId: string; data: AdvData }) => {
  return instance
    .put<AdvTypes>(companyAdvHomePath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteAdv = async ({ companyId }: { companyId: string }) => {
  return instance.delete(companyAdvHomePath(companyId)).catch(e => e.response as AxiosError<ApiError> as never);
};

export const uploadAdvImage = async ({
  companyId,
  filename,
  assetType,
}: {
  companyId: string;
  filename: string;
  assetType: 'home' | 'modal';
}) => {
  const response = await instance.post(`/companies/${companyId}/advertisements/upload-image`, {
    filename,
    asset_type: assetType,
  });
  return response.data;
};
